/* eslint-disable react/prop-types */
import Footer from "@/components/footer/Footer";
import Header from "@/components/header/Header";
import DefaultPageContent from "@/components/page-templates/DefaultPageContent";

function DefaultPageTemplate({pageData}) {
  return (
    <>
      <Header title={pageData.title?.rendered} />
      <main className="pt-[5rem] md:pt-[9rem]">
        <DefaultPageContent pageData={pageData} />
      </main>
      <Footer />
    </>
  )
}

export default DefaultPageTemplate